import { UntypedFormGroup } from '@angular/forms';

export class ValidatableFormComponent {
  form: UntypedFormGroup;

  validate(): boolean {
    Object.keys(this.form.controls).forEach(k => {
      this.form.get(k).markAsTouched();
      // this.form.get(k).updateValueAndValidity();
    });

    return this.form.valid;
  }
}
